import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "inputField",
    "idField",
    "destroyField"
  ]

  toggleDestroyField () {
    if ((this.inputFieldTarget.value === "" || this.inputFieldTarget.value === null) && this.idFieldTarget.value) {
      this.destroyFieldTarget.value = true
    } else {
      this.destroyFieldTarget.value = false
    }
  }
}
